import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  getProductDisplayName,
  getProductTokenCount,
  readNumericValue
} from "../../utils/getTokenProductUtils";

const TokenAllPlans = ({ products, selectedProductId, onSelectProduct, loading }) => {
  const { t } = useTranslation("common");

  if (loading) {
    return (
      <div className="card" style={{ marginTop: 16 }}>
        <div className="card-header">
          <div className="card-title">{t("All Plans")}</div>
        </div>
        <div className="dashboard-loading get-token-section-loading">{t("Fetching...")}</div>
      </div>
    );
  }

  if (!products.length) return null;

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div className="card-header">
        <div className="card-title">{t("All Plans")}</div>
      </div>
      <div className="plan-list">
        {products.map((product, index) => {
          const name = getProductDisplayName(product);
          const tokens = getProductTokenCount(product);
          const price = readNumericValue(product.list_price, 0).toFixed(2);
          const isSelected = String(product.id) === String(selectedProductId);
          const detailClass =
            index === products.length - 1 && products.length > 1
              ? "orange"
              : index >= 2
                ? "purple"
                : "";

          return (
            <button
              key={product.id}
              type="button"
              className={`plan-row${isSelected ? " selected" : ""}`}
              onClick={() => onSelectProduct(product.id)}>
              <span className="plan-row-name">{name}</span>
              <span className={`plan-row-detail${detailClass ? ` ${detailClass}` : ""}`}>
                {tokens.toLocaleString()} tokens · ${price}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

TokenAllPlans.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedProductId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelectProduct: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

TokenAllPlans.defaultProps = {
  selectedProductId: null,
  loading: false
};

export default TokenAllPlans;
